/* eslint-disable */
export default {
//iiot项目  定义服务

  CONFIGMANAGE: 'configmanage'+'/',
  USER: 'user'+'/',
  FOTA: 'fota'+'/',
  FEEDBACK: 'feedback'+'/',
  LOGSERVER: 'logserver'+'/',
  DEVICE: 'device'+'/',
  DEVICEANDFUNC: 'devicestaandfunc'+'/',
  SCENEMANAGE: 'scenemanage' + '/',
  SCENEENGINE: 'sceneengine' + '/',

  DEVICEHISTORY: "devicehistory" + '/',
  DEVICECUSTOMER: "devicecustomer" + '/',
  CHARTGPTSERVER: "chartgptserver" + '/',

  EMQXHTTPAUTH: "emqxhttpauth" + '/',

  COMBINECONTROLL: "combinecontroll" + '/',
  IOTCARD: "iotcard" + '/',


  URL_API_getIotcardListByPage: 'api/getIotcardListByPage', 
  URL_API_createIotcard: 'api/createIotcard', 
  URL_API_updateIotcard: 'api/updateIotcard', 
  URL_API_deviceBandIotcard: 'api/deviceBandIotcard', 

  URL_API_getDeviceModelConfigByPage: 'api/getDeviceModelConfigByPage', 

  
// 一键执行服务

  URL_API_getCombineAutoListByPage: 'api/getCombineAutoListByPage', 
  URL_API_getCombineControllListByPage: 'api/getCombineControllListByPage', 

  URL_API_deleteCombineControll: 'api/deleteCombineControll', 
  URL_API_deleteCombineAuto: 'api/deleteCombineAuto', 

  URL_API_editCombineAuto: 'api/editCombineAuto', 
  URL_API_editCombineControll: 'api/editCombineControll', 

  URL_API_addCombineControll: 'api/addCombineControll', 
  URL_API_addCombineAuto: 'api/addCombineAuto', 


// RTM配置
  URL_API_getRTMConfigListByPage: 'api/getRTMConfigListByPage', 
  URL_API_addRTMConfig: 'api/addRTMConfig', 
  URL_API_editRTMConfig: 'api/editRTMConfig', 
  URL_API_deleteRTMConfig: 'api/deleteRTMConfig', 


  URL_API_getRTMProductListByPage: 'api/getRTMProductListByPage', 
  URL_API_editRTMProduct: 'api/editRTMProduct', 

  URL_API_getRTMDeviceListByPage: 'api/getRTMDeviceListByPage', 
  URL_API_addRTMDevice: 'api/addRTMDevice', 
  URL_API_editRTMDevice: 'api/editRTMDevice', 
  URL_API_deleteRTMDevice: 'api/deleteRTMDevice', 


// AI
    URL_API_getChartgptDeviceRoleByPage: 'api/getChartgptDeviceRoleByPage', 
    URL_API_editChartgptDeviceRole: 'api/editChartgptDeviceRole', 
  
//  iiot项目 api
  
  URL_API_getUserInfoByPhoneNumber: 'api/getUserInfoByPhoneNumber', 
  URL_API_LOGIN: 'api/login', 
  URL_API_LOGOUT: 'api/logout', 
  URL_API_GETALLUSERLISTBYPAGE: 'api/getAllUserListByPage', 
  URL_API_REGISTER: 'api/register', 
  URL_API_EDITUSERINFO: 'api/editUserInfo', 
  URL_API_RESETPWD:'api/resetpwd', 
  URL_API_RESETPWDBYUSER:'api/resetpwdByUser', 
  URL_API_DELETEUSERINFO: 'api/deleteUserInfo', 
  URL_API_GETONEDEVICE: 'api/getOneDevice', 
  URL_API_GETSENSORFUNC: 'api/getSensorFunc', 
  URL_API_GETLASTHOME: 'api/getLastHome', 
  URL_API_GETLASTPHOTO: 'api/getLastPhoto', 
  URL_API_deleteDeviceRecord:  'api/deleteDeviceRecord', 
  URL_API_GETALLANIMALLISTBYPAGE: 'api/getAllAnimalListByPage', 

  
  URL_API_GETAUTHLISTBYPAGE: 'api/getAuthListByPage', 
  URL_API_GETDEVICESALESLISTBYPAGE: 'api/getDeviceSalesListByPage', 
  URL_API_DELETEDEVICESALES: 'api/deleteDeviceSales', 
  URL_API_ADDDEVICESALES: 'api/addDeviceSales', 
  URL_API_editDeviceSalesBySalesid : 'api/editDeviceSalesBySalesid',



  URL_API_GETONEUPLOGLISTBYPAGE: 'api/getOneupLogListByPage', 
  URL_API_GETONEDOWNLISTBYPAGE: 'api/getOnedownLogListByPage', 


  URL_API_getDeviceLoginLogListByPage: 'api/getDeviceLoginLogListByPage', 
  URL_API_getDeviceClientsLogListByPage: 'api/getDeviceClientsLogListByPage', 
  URL_API_getUserExportLogListByPage: 'api/getUserExportLogListByPage', 
  URL_API_beginUserExportLog: 'api/beginUserExportLog', 

  URL_API_GETUPLOGLISTBYPAGE: 'api/getupLogListByPage', 
  URL_API_GETDOWNLISTBYPAGE: 'api/getdownLogListByPage', 
  URL_API_GETCHARTGPTLOGLISTBYPAGE: 'api/getAllChartGPTLogListByPage', 

  URL_API_GETDEVICERECORDLISTBYPAGE: 'api/getDeviceRecordListByPage', 
  
  URL_API_DELETEDEVICEBYID: 'api/deleteDeviceById', 

  URL_API_DELETEAUTHDEVICE: 'api/deleteAuthDevice', 
  URL_API_ADDAUTHDEVICE: 'api/addAuthDevice', 
  URL_API_CREATEDEVICE: 'api/createDevice', 

  URL_API_EDITDEVICEBANDINFO: 'api/editDeviceBandInfo', 
  URL_API_GETDEVICELISTBYPAGE: 'api/getDeviceListByPage', 
  URL_API_GETSCENEDEVICELISTBYPAGE: 'api/getSceneDeviceListByPage', 


  URL_API_GETTOTAL: 'api/getTotal', 
  URL_API_GETONLINEHISTORY: 'api/getOnlineHistory', 

  URL_API_GETSOFTWARELISTBYPAGE: 'api/getSoftwareListByPage', 
  URL_API_DELETESOFTWAREBYID: 'api/deleteSoftwareById', 
  URL_API_EDITSOFTWAREINFO: 'api/editSoftwareInfo', 
  URL_API_ADDSOFTWARE: 'api/addSoftware', 
  URL_API_GETFOTAMANAGELISTBYPAGE: 'api/getFotaManageListByPage', 
  URL_API_DELETEFOTABYID: 'api/deleteFotaById', 
  URL_API_ADDFOTA: 'api/addFota', 
  URL_API_EDITFOTAINFO: 'api/editFotaInfo', 
  URL_API_GETSCHELEJOBLISTLISTBYPAGE: 'api/getScheduleJobListByPage', 
  URL_API_DELETESCHEDULEJOB: 'api/deleteScheduleJob', 


  URL_API_GETCONFIGSENSORFUNCLISTBYPAGE: 'api/getConfigSensorFuncListByPage', 
  URL_API_DELETECONFIGSENSORFUNCBYID: 'api/deleteConfigSensorFuncById', 
  URL_API_EDITCONFIGSENSORFUNC: 'api/editConfigSensorFunc', 
  URL_API_ADDCONFIGSENSORFUNC: 'api/addConfigSensorFunc', 

  URL_API_ADDSENSORFUNC: 'api/addSensorFunc', 
  URL_API_EDITSENSORFUNC: 'api/editSensorFunc', 
  URL_API_DELETESENSORFUNC: 'api/deleteSensorFunc',

  URL_API_EDITDEVICEINFO: 'api/editDeviceInfo', 

  URL_API_GETCONFIGSENSORSTATUSLISTBYPAGE: 'api/getConfigSensorStatusListByPage', 
  URL_API_DELETECONFIGSENSORSTATUSBYID: 'api/deleteConfigSensorStatusById', 
  URL_API_EDITCONFIGSENSORSTATUS: 'api/editConfigSensorStatus', 
  URL_API_ADDCONFIGSENSORSTATUS: 'api/addConfigSensorStatus', 


  URL_API_ADDSENSORSTATUS: 'api/addSensorStatus', 
  URL_API_EDITSENSORSTATUS: 'api/editSensorStatus', 
  URL_API_DELETESENSORSTATUS: 'api/deleteSensorStatus', 
  URL_API_GETSENSORSTATUS: 'api/getSensorStatus', 



  // 项目配置
  URL_API_GETCONFIGPROJECTLISTBYPAGE: 'api/getConfigProjectListByPage', 
  URL_API_EDITCONFIGPROJECT:'api/editConfigProject',
  URL_API_DELETECONFIGPROJECT :"api/deleteConfigProject",
  URL_API_ADDCONFIGPROJECT:"api/addConfigProject",
  URL_API_GETCONFIGPRODUCTLISTBYPAGE: 'api/getConfigProductListByPage', 
  URL_API_editConfigProduct: 'api/editConfigProduct', 

  

  // 硬件配置
  URL_API_GETCONFIGHARDWARETYPELISTBYPAGE: 'api/getConfigHardwareTypeListByPage', 
  URL_API_EDITCONFIGHARDWARE :"api/editConfigHardware",
  URL_API_DELETECONFIGHARDWARE:"api/deleteConfigHardware",
  URL_API_ADDCONFIGHARDWARE:"api/addConfigHardware",

  // 用户反馈
  URL_API_ADDFEEDBACK:"api/addfeedback",
  URL_API_GETFEEDBACKLISTBYPAGE:"api/getFeedbackListByPage",
  URL_API_EDITFEEDBACK:"api/editFeedback",
  URL_API_DELETEFEEDBACK:"api/deleteFeedback",

  URL_API_GETONLINEHISTORY:"api/getOnlineHistory",


//微服务日志 API
  URL_API_GETLOGUSERLISTBYPAGE: 'api/getLogUserListByPage', 
  URL_API_GETCONFIGMANAGELISTBYPAGE: 'api/getLogConfigManageListByPage', 

//角色相关 API
  URL_API_GETROLEBYROLE: 'api/getRoleByRole', 
  URL_API_GETROLEMANAGELISTBYPAGE: 'api/getRoleManageListByPage', 
  URL_API_EDITROLEMANAGE :"api/editRoleManage",
  URL_API_DELETROLEMANAGE:"api/deleteRoleManage",
  URL_API_ADDROLEMANAGE:"api/addRoleManage",
  URL_API_GETROLELIST: 'api/getRoleList', 

// 场景管理
URL_API_GETSCENEMANAGELISTBYPAGE:"api/getSceneManageListByPage",
URL_API_ADDSCENEDEVICE:"api/addSceneDevice",
URL_API_ADDSCENEMANAGE:"api/addSceneManage",
URL_API_EDITSCENEMANAGE:"api/editSceneManage",
URL_API_DELETESCENEMANAGE:"api/deleteSceneManage",
URL_API_getSceneDeviceListByAidCreate : 'api/getSceneDeviceListByAidCreate',
URL_API_addSceneDevice :  'api/addSceneDevice',


// 场景引擎
URL_API_GETSCENEJOBLISTBYPAGE:"api/getSceneJobListByPage",
URL_API_DELETESCENEJOB:"api/deleteSceneJob",
URL_API_EDITSCENEJOB:"api/editSceneJob",
URL_API_ADDSCENEJOB:"api/addSceneJob",



URL_API_EDITSCENEDEVICE:"api/editSceneDevice",
URL_API_DELETESCENEDEVICE:"api/deleteSceneDevice",
URL_API_GETSCENEDEVICELISTBYSCENEID:"api/getSceneDeviceListBySceneId",


// DEVICE TOPIC

URL_API_GETDEVICETOPICLISTBYPAGE:"api/getDeviceTopicListByPage",
URL_API_DELETEDEVICETOPICBYID:"api/deleteDeviceTopicById",
URL_API_EDITDEVICETOPICBYID:"api/editDeviceTopicById",
URL_API_ADDDEVICETOPIC:"api/addDeviceTopic",






  //下面的是之前的废旧代码----------------------------------------

  // 用户信息管理接口
  URL_USER_SIGNIN: 'user/sign-in', 
  URL_USER_SIGNOUT: 'user/sign-out', 
  URL_USER_REGISTERED: 'user/registered',
  URL_USER_GETEMAILCODE: 'user/get-email-code',

  URL_USER_FOGETPASSWORD: 'user/forget-password',
  URL_USER_GETCURRENTUSER: 'user/get-current-user', 
  URL_USER_UPDATE: 'user/update',
  URL_USER_UPDATELOCATION: 'user/update-location',
  URL_USER_LISTLOCATION: 'user/list-locations',
  URL_USER_LIST: 'user/list',
  URL_USER_DELETE: 'user/delete',
  URL_USER_GET: 'user/get',
  URL_USER_JOINGROUP: 'user/join-group',
  URL_USER_FORADMIN: 'user/for-admin',

  // 分组管理
  URL_GROUP_LIST: 'group/list',
  URL_GROUP_GET: 'group/get',
  URL_GROUP_ADDGROUP: 'group',
  URL_GROUP_GROUPMEMBER: 'group/group-members',
  URL_GROUP_UPDATE: 'group/update',
  URL_GROUP_DELETE: 'group/delete',

// 意见反馈
  URL_FEEDBACKOPINION_INSERT: 'opinion-feedback/insert',
  URL_FEEDBACKOPINION_GET:  'opinion-feedback/get',
  URL_FEEDBACKOPINION_DELETE :  'opinion-feedback/delete',
  URL_FEEDBACKOPINION_LIST :  'opinion-feedback/list',
  URL_FEEDBACKOPINION_UPDATE :  'opinion-feedback/update',


// 内容管理
  URL_CONTENT_LIST: 'content/list',
  URL_CONTENT_GET: 'content/get',
  URL_CONTENT_INSERT: 'content/insert',
  URL_CONTENT_UPDATE: 'content/update',
  URL_CONTENT_DELETE: 'content/delete',

// 文件管理
  URL_FILE_UPLOAD: 'file/upload',
  URL_FILE_BAIDUEDITOR: 'file/bai-du-editor'

}
